/* The four states an author's article can be in, in the author's own words.
   One place, because the list badge, the tally strip and the composer header
   all have to say the same thing about the same post. */

export const BLOG_STATUS = {
  draft: {
    label: 'Draft',
    short: 'Drafts',
    // Tailwind classes rather than tokens: the dashboard's badges are written
    // this way throughout (see GoLiveTab, OrdersTab).
    badge: 'bg-stone-100 text-stone-600 border-stone-200',
    dot: 'bg-stone-400',
    note: 'Only you can see this. Submit it when it is ready.',
  },
  pending_review: {
    label: 'Waiting for review',
    short: 'In review',
    badge: 'bg-amber-50 text-amber-700 border-amber-200',
    dot: 'bg-amber-500',
    note: 'With the admin team. You will be notified once it is decided.',
  },
  published: {
    label: 'Published',
    short: 'Published',
    badge: 'bg-green-50 text-green-700 border-green-200',
    dot: 'bg-green-500',
    note: 'Live on the public blog.',
  },
  rejected: {
    label: 'Needs changes',
    short: 'Needs changes',
    badge: 'bg-red-50 text-red-700 border-red-200',
    dot: 'bg-red-500',
    note: 'Read the note from the admin, make the changes and submit again.',
  },
}

/** Never crash on a status the API adds later — show it, plainly. */
export const statusMeta = (status) =>
  BLOG_STATUS[status] ?? {
    label: String(status ?? '').replace(/_/g, ' ') || 'Unknown',
    short: String(status ?? ''),
    badge: 'bg-stone-100 text-stone-600 border-stone-200',
    dot: 'bg-stone-400',
    note: '',
  }

/** The order the tally strip reads in — what needs the author's attention first. */
export const STATUS_ORDER = ['rejected', 'draft', 'pending_review', 'published']

export const dateLabel = (iso) => {
  if (!iso) return '—'
  const d = new Date(iso)
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}
